import styled from 'styled-components';

export const Wrap = styled.div`
  position:relative;
  background:url(${require('../../../assets/img/2_21.png').default})center;
  background-size:cover;
  /* height:calc(100% - 1.06rem); */
  padding: 0.75rem 0.5rem;
  section{
    width:100%;
    height:10.66rem;
    background-color:#fff;
    padding:0 .57rem;
    h3{
      padding:.47rem 0;
      font-size:17px;
    }
    .box{
      display:grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: .2rem;
      grid-row-gap: .2rem;

      .item{
       div{
         position:relative;
         width:100%;
         display:flex;
         justify-content:space-between;
         align-items:center;
         background-color:#005bab;
         height:.57rem;
         padding-left:.3rem;
         padding-right:.14rem;
         margin-top:-.2rem;
          h5{
            font-size:.24rem;
            color: #fff;
            margin-bottom:0;
          }
          img{
            width:.16rem;
            color: #fff;
          }
       }
      }

    }
  }

`